import React, { useEffect, useState, useCallback } from 'react';
import { Tabs, message } from 'antd';
import AxiosOICStat from 'AxiosOICStat';
import IrenaCountryMappingTab from './IrenaCountryMappingTab';
import IrenaIndicatorMappingTab from './IrenaIndicatorMappingTab';
import IrenaConvertFetchTab from './IrenaConvertFetchTab';

const { TabPane } = Tabs;

const IrenaTabGroup = () => {
  const [countryMappings, setCountryMappings] = useState([]);
  const [indicatorMappings, setIndicatorMappings] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCountryMappings = useCallback(async () => {
    try {
      const res = await AxiosOICStat.get("/external_api/irena/country-mappings");
      setCountryMappings(res.data?.mappings || res.data || []);
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.message || "Failed to load IRENA country mappings.";
      message.error(detail);
    }
  }, []);

  const fetchIndicatorMappings = useCallback(async () => {
    try {
      const res = await AxiosOICStat.get("/external_api/irena/indicator-mappings");
      setIndicatorMappings(res.data?.mappings || res.data || []);
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.message || "Failed to load IRENA indicator mappings.";
      message.error(detail);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchCountryMappings(), fetchIndicatorMappings()]).finally(() => setLoading(false));
  }, [fetchCountryMappings, fetchIndicatorMappings]);

  return (
    <Tabs defaultActiveKey="comparison">
      <TabPane tab="Comparison" key="comparison">
        <IrenaConvertFetchTab
          countryMappings={countryMappings}
          indicatorMappings={indicatorMappings}
        />
      </TabPane>
      <TabPane tab="Indicator Mapping" key="indicator">
        <IrenaIndicatorMappingTab
          indicatorMappings={indicatorMappings}
          onRefreshIndicatorMappings={fetchIndicatorMappings}
        />
      </TabPane>
      <TabPane tab="Country Mapping" key="country">
        <IrenaCountryMappingTab
          countryMappings={countryMappings}
          onRefreshCountryMappings={fetchCountryMappings}
        />
      </TabPane>
    </Tabs>
  );
};

export default IrenaTabGroup;
